import {
  coreExtensionData,
  createExtension,
  createExtensionInput,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { Layout } from './Layout';
import { SidebarContent } from './Sidebar';

/**
 * The app's frame, replacing the app plugin's own `app/layout`, which is
 * core-components' MUI `SidebarPage`. Same id, same inputs: the nav from
 * `SidebarContent` and the routed page.
 */
const AppLayout = createExtension({
  name: 'layout',
  attachTo: { id: 'app/root', input: 'children' },
  inputs: {
    nav: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
    content: createExtensionInput([coreExtensionData.reactElement], {
      singleton: true,
    }),
  },
  output: [coreExtensionData.reactElement],
  factory: ({ inputs }) => [
    coreExtensionData.reactElement(
      <Layout
        nav={inputs.nav.get(coreExtensionData.reactElement)}
        content={inputs.content.get(coreExtensionData.reactElement)}
      />,
    ),
  ],
});

export const navModule = createFrontendModule({
  pluginId: 'app',
  extensions: [AppLayout, SidebarContent],
});
